import { render } from "./ProsesHariLibur.vue?vue&type=template&id=90c3738c"
import script from "./ProsesHariLibur.vue?vue&type=script&lang=js"
export * from "./ProsesHariLibur.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__